
import {defineComponent} from "vue";
import {AuthContext} from "@/context/AuthContext";

export default defineComponent({
  name: "UserModeBadge",
  data() {
    return {
      now: Date.now() as number,
      intervalId: null as ReturnType<typeof setInterval> | null,
    };
  },
  computed: {
    remainingTime(): string {
      // The token is cleared just before the SSO redirect on leave or expiry, while this badge is still mounted
      const expiresAt: number = AuthContext.oauth2Token?.expiresAt ?? this.now;
      const remainingSeconds: number = Math.max(0, Math.floor((expiresAt - this.now) / 1000));
      const minutes: number = Math.floor(remainingSeconds / 60);
      const seconds: number = remainingSeconds % 60;

      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
  },
  mounted() {
    this.intervalId = setInterval((): void => {
      this.now = Date.now();
    }, 1000);
  },
  beforeUnmount() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
});
